import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import styles from './VpVideoPlayer.module.less';

export const VpVideoPlayer = ({
  mediaUrl,
  onLoad,
  thumbnailUrl,
  onEnd = () => {},
  noDownload = false,
  autoPlay = false,
  muted = false,
  ...rest
}) => {
  const videoPlayerRef = useRef(null);

  const [orientation, setOrientation] = useState(styles.landscape);

  useEffect(() => {
    const video = videoPlayerRef.current;

    const checkOrientation = () => {
      const aspectRatio = video.videoWidth / video.videoHeight;
      setOrientation(aspectRatio > 1 ? styles.landscape : styles.portrait);
    };

    video.addEventListener('loadedmetadata', checkOrientation);

    return () => {
      video.removeEventListener('loadedmetadata', checkOrientation);
    };
  }, [mediaUrl]);

  const handleOnLoad = () => {
    onLoad && onLoad();
  };

  return (
    <section className={`${styles.vpVideoContainer} ${orientation}`} {...rest}>
      <video
        ref={videoPlayerRef}
        onLoadedData={handleOnLoad}
        autoPlay={autoPlay}
        controls
        onEnded={onEnd}
        muted={muted}
        {...(noDownload ? { controlsList: 'nodownload' } : {})}
        {...(thumbnailUrl ? { poster: thumbnailUrl } : {})}
      >
        <source src={mediaUrl} key={mediaUrl} />
      </video>
    </section>
  );
};

VpVideoPlayer.propTypes = {
  mediaUrl: PropTypes.string,
  thumbnailUrl: PropTypes.string,
  onLoad: PropTypes.func,
  onEnd: PropTypes.func,
  noDownload: PropTypes.bool,
  autoPlay: PropTypes.bool,
  muted: PropTypes.bool,
};

export default VpVideoPlayer;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpVideoPlayer/VpVideoPlayer.jsx